import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { TopgradserviceService } from '../topgradservice.service';

@Injectable({
  providedIn: 'root'
})
export class LoggedUserGuard implements CanActivate {

  constructor(private service: TopgradserviceService, private router: Router){
    
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const userDetail = JSON.parse(localStorage.getItem("userDetail"));

    if(this.service.getToken()){
        if(userDetail?.role == 'admin'){
          this.router.navigate(['admin/my-task'])
        } else if(userDetail?.role == 'student'){
          if(!userDetail.student_profile){
            this.router.navigate(['student/onboarding'])
          }else{
            this.router.navigate(['student/dashboard'])
          }
        } else if(userDetail?.role == 'staff'){
            this.router.navigate(['staff/my-task'])
        } else if(userDetail?.role == 'employee'){
          if(!userDetail.company_profile){
            this.router.navigate(['employer/onboarding'])
          }else{
            this.router.navigate(['employer/dashboard'])
          }
        }
        return false
      } else {
        // this.router.navigate(['/student-login']);
        return true;
      }
  }
}
